import { Box, IconButton, Tooltip } from "@mui/material";
import WhatsappIcon from "@/assets/icons/lead-page/whatsapp-icon";
import { buildWhatsappLink } from "@/modules/common/utils/customer-contact";

const ContactWhatsappIcon = ({
  phoneNumber,
  username,
}: {
  phoneNumber?: string;
  username?: string;
}) => {
  const link = buildWhatsappLink({ phone: phoneNumber, username });
  return (
    <Tooltip title={link ? "Open WhatsApp" : "No usable contact details"}>
      <Box component="span" sx={{ display: "inline-flex" }}>
        <IconButton
          aria-label="Open WhatsApp"
          disabled={!link}
          sx={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            backgroundColor: "#25d366",
            padding: "8px",
            "&:hover": { backgroundColor: "#1da851" },
            "&.Mui-disabled": { backgroundColor: "#25d366", opacity: 0.5 },
          }}
          onClick={(event) => {
            event.stopPropagation();
            if (link) window.open(link, "_blank", "noopener,noreferrer");
          }}
        >
          <WhatsappIcon fill="white" />
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export default ContactWhatsappIcon;
